const Center = () => import('@/views/patrol/Center')
const Index = () => import('@/views/patrol/Index')
export default [{
  path: '/patrol',
  meta: {
    title: '品质巡查',
    hasBack: false
  },
  components: {
    default: Center,
    right: Index
  },
  redirect: '/patrol/taskList',
  children: [{
    path: '/patrol/taskList',
    meta: {
      title: '巡查任务',
      hasBack: false,
      activeMenu: '/home/board'
    },
    component: () => import('@/views/patrol/TaskList')
  }, {
    path: '/patrol/issueList',
    meta: {
      title: '巡查问题',
      hasBack: false,
      activeMenu: '/home/board'
    },
    component: () => import('@/views/patrol/IssueList')
  }]
}]
